import {
    ArtifactEvidence,
    ArtifactFrame,
    ArtifactLifecycleStatusBadge,
} from '@apps/web/routes/_app/admin/agent/artifacts/frame';
import {
    type AdminArtifactRendererProps,
    stringValue,
    toRecord,
} from '@apps/web/routes/_app/admin/agent/artifacts/shared';
import { sanitizeFilenamePart } from '@apps/web/routes/_app/admin/agent/payload_viewer_shared';
import { AdminAgentToolOutputFile } from '@apps/web/routes/_app/admin/agent/tool_output_renderer';

export function AdminToolResultFullArtifact({
    artifact,
}: AdminArtifactRendererProps) {
    const payload = toRecord(artifact.payload);
    const toolName =
        stringValue(payload['tool_name']) ?? artifact.title ?? 'tool-result';
    const result = payload['result'] ?? artifact.payload;

    return (
        <ArtifactFrame
            artifact={artifact}
            status={
                <ArtifactLifecycleStatusBadge
                    lifecycleStatus={artifact.lifecycle_status}
                />
            }
        >
            <ArtifactEvidence artifact={artifact} />
            <div className="overflow-hidden rounded-[8px] border border-[#ededed] bg-[#fcfdfd]">
                <AdminAgentToolOutputFile
                    file={{
                        id: `${artifact.id}:full-result`,
                        title: 'Full result',
                        filename: `${sanitizeFilenamePart(toolName)}-full-result.json`,
                        value: result,
                        sourceLabel: toolName,
                    }}
                />
            </div>
        </ArtifactFrame>
    );
}
